import { APP_SAGE_KEY, APP_SAGE_AUTH_URL } from "@/constants/config";
import ErrorMessages from '@/mixins/ErrorMessages'

export default {
    mixins: [ErrorMessages],
    methods: {
        async sageAuthHandler(status) {
            if (status === 401) {
                // const current_url = window.location.href
                // const app_origin_url = window.location.origin
                // window.open(`${APP_SAGE_AUTH_URL}&client_id=${APP_SAGE_KEY}&response_type=code&scope=openid offline_access&redirect_uri=${app_origin_url}/pages/sage-verification&state=${current_url}`, '_blank');
                this.showErrorMessageWithTitle('Sage Session Expired', 'Your connection to Sage has expired. Please re-authenticate in Settings to restore access.')
            }
        }
    }
}
